import { render, staticRenderFns } from "./SubmissionFormQuestions.vue?vue&type=template&id=ebba4a8e&"
import script from "./SubmissionFormQuestions.vue?vue&type=script&lang=js&"
export * from "./SubmissionFormQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports